import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../global.css';
import NeuralCanvas from '../../components/NeuralCanvas';
import WordmarkLogo from '../../components/WordmarkLogo';
import AuthFooter from '../../components/AuthFooter';
import api from '../../store/axios';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong. Try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-layout">
      <NeuralCanvas />

      <div className="signup-shell">
        <div className="signup-left">
          <WordmarkLogo size={22} />
          <div style={{ margin: 'auto 0', display: 'flex', flexDirection: 'column', gap: 32, maxWidth: 440 }}>
            <div className="dash-sub">ACCOUNT SECURITY</div>
            <h1 className="signup-title">Locked out?<br /><em>We've got you.</em></h1>
            <p className="signup-sub">It happens to the best of us. Enter your email and we'll send you a secure link to set a new password.</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14, paddingTop: 28, borderTop: '1px solid var(--line)' }}>
              {[
                ['01', 'Enter your email', 'The one you used to sign up, personal or work.'],
                ['02', 'Check your inbox', 'A reset link arrives in seconds. Check spam if needed.'],
                ['03', 'Set a new password', 'Click the link and choose something secure.'],
              ].map(([n, t, d]) => (
                <div key={n} style={{ display: 'flex', gap: 16 }}>
                  <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--accent)', letterSpacing: '0.08em', flexShrink: 0, paddingTop: 2 }}>{n}</div>
                  <div>
                    <div style={{ fontSize: 14, color: 'var(--fg)', marginBottom: 4 }}>{t}</div>
                    <div style={{ fontSize: 13, color: 'var(--fg-mid)', lineHeight: 1.55 }}>{d}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="signup-right">
          <form className="signup-form" onSubmit={handleSubmit}>
            <div>
              <div className="dash-sub" style={{ marginBottom: 10 }}>RESET PASSWORD</div>
              <h2 className="signup-title" style={{ fontSize: 30 }}>Forgot your<br /><em>password?</em></h2>
            </div>

            {error && <div className="alert alert-error">{error}</div>}
            {sent && (
              <div className="alert alert-success">
                <span>Check your inbox — reset link sent to <strong>{email}</strong>. It expires in 10 minutes.</span>
              </div>
            )}

            {!sent && (
              <>
                <div className="field">
                  <label>Email address</label>
                  <input type="email" required placeholder="you@email.com"
                    value={email} onChange={e => setEmail(e.target.value)} />
                </div>
                <button type="submit" className="btn btn-primary btn-lg" style={{ justifyContent: 'center' }} disabled={loading}>
                  {loading ? <span className="btn-loader" /> : null}
                  {loading ? 'Sending…' : 'Send reset link'}
                </button>
              </>
            )}

            <div style={{ textAlign: 'center', fontSize: 12, color: 'var(--fg-dim)' }}>
              <Link to="/login" style={{ color: 'var(--fg-mid)' }}>← Back to sign in</Link>
            </div>
          </form>
        </div>
      </div>

      <AuthFooter />
    </div>
  );
}
